var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCenterLeftbarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2660_15691)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2660_15691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.97226 0.126896C4.05425 0.0451102 4.16532 -0.000829888 4.28113 -0.000854492H9.71838C9.83419 -0.000829888 9.94526 0.0451102 10.0273 0.126896L13.872 3.97165C13.9538 4.05364 13.9997 4.16471 13.9998 4.28052V9.71777C13.9997 9.83358 13.9538 9.94465 13.872 10.0266L10.0273 13.8714C9.94526 13.9532 9.83419 13.9991 9.71838 13.9991H4.28113C4.16532 13.9991 4.05425 13.9532 3.97226 13.8714L0.127506 10.0266C0.0457205 9.94465 -0.000219537 9.83358 -0.000244141 9.71777V4.28052C-0.000219537 4.16471 0.0457205 4.05364 0.127506 3.97165L3.97226 0.126896ZM4.46226 0.874146L0.874756 4.46165V9.53664L4.46226 13.1241H9.53726L13.1248 9.53664V4.46165L9.53726 0.874146H4.46226Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59788 5.0619C4.59668 5.09015 4.60128 5.11836 4.61138 5.14477C4.62149 5.17119 4.63689 5.19526 4.65664 5.2155C4.67639 5.23574 4.70008 5.25173 4.72624 5.26248C4.7524 5.27324 4.78048 5.27852 4.80876 5.27802H5.53063C5.65138 5.27802 5.74763 5.17915 5.76338 5.05927C5.84213 4.48527 6.23588 4.06702 6.93763 4.06702C7.53788 4.06702 8.08738 4.36715 8.08738 5.08902C8.08738 5.64465 7.76013 5.90015 7.24301 6.28865C6.65413 6.71652 6.18776 7.21615 6.22101 8.02727L6.22363 8.21715C6.22455 8.27455 6.248 8.3293 6.28893 8.36957C6.32985 8.40984 6.38497 8.4324 6.44238 8.43239H7.15201C7.21002 8.43239 7.26566 8.40935 7.30669 8.36833C7.34771 8.3273 7.37076 8.27166 7.37076 8.21364V8.12177C7.37076 7.49352 7.60963 7.31065 8.25451 6.82152C8.78738 6.4164 9.34301 5.96665 9.34301 5.02252C9.34301 3.7004 8.22651 3.06165 7.00413 3.06165C5.89551 3.06165 4.68101 3.5779 4.59788 5.0619ZM5.96026 10.1045C5.96026 10.5709 6.33213 10.9156 6.84401 10.9156C7.37688 10.9156 7.74351 10.5709 7.74351 10.1045C7.74351 9.62152 7.37601 9.28202 6.84313 9.28202C6.33213 9.28202 5.96026 9.62152 5.96026 10.1045Z",
    fill: "#212529"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2660_15691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2660_15691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenterLeftbarIcon);
export default __webpack_public_path__ + "static/media/help_center_leftbar_icon.45b44fec5bbac35f52a070d1679616e2.svg";
export { ForwardRef as ReactComponent };